import { useRef } from 'react'
import { motion, useReducedMotion } from 'framer-motion'
import { Image } from '../Image'
import type { Product } from '../../types'
import { Button } from '../Button'
import { useMousePosition } from '../../hooks/useMousePosition'
import styles from './ProductCard.module.css'

interface ProductCardProps {
  product: Product
  onAddToCart: (product: Product) => void
}

export function ProductCard({ product, onAddToCart }: ProductCardProps) {
  const colorClass = product.color ? styles[product.color] : ''
  const cardRef = useRef<HTMLDivElement>(null)
  const { x, y, isHovering } = useMousePosition(cardRef)
  const prefersReduced = useReducedMotion()

  const rotateX = prefersReduced ? 0 : isHovering ? y * -8 : 0
  const rotateY = prefersReduced ? 0 : isHovering ? x * 8 : 0

  return (
    <div ref={cardRef} className={styles.tiltContainer}>
      <motion.article
        className={`${styles.card} ${colorClass}`}
        animate={{ rotateX, rotateY }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{ transformStyle: 'preserve-3d' }}
      >
        <div className={styles.imageWrapper}>
          <Image
            src={product.image}
            alt={product.name}
            className={styles.image}
            lazy={true}
          />
          {product.color && <span className={styles.colorBadge}>{product.color}</span>}
        </div>
        <div className={styles.content}>
          <span className={styles.type}>{product.type === 'frame' ? 'Marco' : 'Cubierta'}</span>
          <h3 className={styles.name}>{product.name}</h3>
          <p className={styles.description}>{product.description}</p>
          <div className={styles.footer}>
            <span className={styles.price}>
              {product.price.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
            </span>
            <Button
              size="sm"
              onClick={() => onAddToCart(product)}
              disabled={!product.inStock}
              aria-label={`Añadir ${product.name} al carrito`}
            >
              {product.inStock ? 'Añadir al carrito' : 'Agotado'}
            </Button>
          </div>
        </div>
      </motion.article>
    </div>
  )
}
